import NextLink from 'next/link'
import { type ReactNode } from 'react'

import { type SanityFrameBuilderLink } from '../../data/sanity/queries/types/content'
import { getLinkPageUrl } from '../../lib/routes'

interface LinkProps {
  link: SanityFrameBuilderLink
  className?: string
  children?: ReactNode
}

const Link = ({ link, className, children }: LinkProps) => {
  // External link
  const url = link.url

  if (url) {
    return (
      <a
        href={url}
        target={url && !url.match('^mailto:') ? '_blank' : '_self'}
        rel="noopener noreferrer"
        className={className}
      >
        {children}
      </a>
    )
  }

  // Internal page
  const pageType = link.page?._type
  const pageSlug = link.page?.slug?.current

  if (!pageType) {
    return null
  }

  const pageUrl = getLinkPageUrl(pageType, pageSlug)

  return (
    <NextLink href={pageUrl}>
      <button role="link" className={className}>
        {children}
      </button>
    </NextLink>
  )
}

export default Link
